"use client"

import { useState } from "react"
import styled from "styled-components"
import Card from "../ui/Card"
import Tabs from "../ui/Tabs"
import AdvancedChart from "../widgets/AdvancedChart"
import ExchangeRateWidget from "../widgets/ExchangeRateWidget"

const ChartCard = styled(Card)`
  width: 100%;
`

const ChartHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const TitleContainer = styled.div``

const ChartTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
`

const ChartDescription = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.secondaryText};
`

const ChartContent = styled.div`
  padding: 16px;
`

function MainChartSection() {
  const [activeTab, setActiveTab] = useState("btc")

  const tabs = [
    { id: "btc", label: "BTC/USDT" },
    { id: "eth", label: "ETH/USDT" },
    { id: "xrp", label: "XRP/USDT" },
    { id: "eos", label: "EOS/USDT" },
  ]

  const getSymbolForTab = (tabId) => {
    const symbols = {
      btc: "BTCUSDT",
      eth: "ETHUSDT",
      xrp: "XRPUSDT",
      eos: "EOSUSDT",
    }
    return symbols[tabId] || "BTCUSDT"
  }

  return (
    <ChartCard>
      <ChartHeader>
        <HeaderContent>
          <TitleContainer>
            <ChartTitle>Market Chart</ChartTitle>
            <ChartDescription>Real-time cryptocurrency price charts</ChartDescription>
          </TitleContainer>
          <ExchangeRateWidget />
        </HeaderContent>
      </ChartHeader>
      <ChartContent>
        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
        <div style={{ marginTop: "16px" }}>
          {tabs.map((tab) => (
            <div key={tab.id} style={{ display: activeTab === tab.id ? "block" : "none" }}>
              <AdvancedChart symbol={getSymbolForTab(tab.id)} height={500} />
            </div>
          ))}
        </div>
      </ChartContent>
    </ChartCard>
  )
}

export default MainChartSection

